import L from 'leaflet';

const initializeFestivalLiveMapBaseRescue = () => {
    const root = document.querySelector('[data-festival-live-map]');

    if (! root) {
        return;
    }

    const canvas = root.querySelector('[data-festival-live-map-canvas]');

    if (! canvas) {
        return;
    }

    window.setTimeout(() => {
        // The primary map owns the canvas whenever Leaflet initialized normally.
        if (canvas.querySelector('.leaflet-pane') || canvas._leaflet_id) {
            return;
        }

        const latitude = Number.parseFloat(root.dataset.festivalLatitude);
        const longitude = Number.parseFloat(root.dataset.festivalLongitude);

        if (! Number.isFinite(latitude) || ! Number.isFinite(longitude)) {
            return;
        }

        const loading = root.querySelector('[data-festival-live-map-loading]');
        const error = root.querySelector('[data-festival-live-map-error]');

        loading?.classList.add('hidden');

        try {
            const map = L.map(canvas, {
                zoomControl: true,
                scrollWheelZoom: false,
            }).setView([latitude, longitude], 16);

            L.tileLayer(
                'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                {
                    maxZoom: 20,
                    attribution: '&copy; OpenStreetMap contributors',
                }
            ).addTo(map);

            L.marker([latitude, longitude])
                .addTo(map)
                .bindPopup(root.dataset.festivalName || 'Festival');

            canvas.dataset.festivalBaseMapRescued = 'true';
            canvas.setAttribute('aria-busy', 'false');

            window.requestAnimationFrame(() => {
                map.invalidateSize({ animate: false });
            });

            if (error) {
                error.textContent = 'The festival base map recovered, but live member-location features did not finish initializing. Refresh once; if this message returns, FestFriends can still show the venue while the live layer is repaired.';
                error.classList.remove('hidden');
            }
        } catch (exception) {
            console.error('Festival Live Map base rescue failed.', exception);
        }
    }, 1200);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFestivalLiveMapBaseRescue, { once: true });
} else {
    initializeFestivalLiveMapBaseRescue();
}

document.addEventListener('livewire:navigated', initializeFestivalLiveMapBaseRescue);
